module.exports = __webpack_public_path__ + "img/Apoptosis-GBM_10X_TPCP.9403782a.png";